import { useQuery } from "@tanstack/react-query";
import { fetchProducts } from "./api/products";

export const useSearchProducts = () => {
  return useQuery({
    queryKey: ["search-products"],
    queryFn: () => fetchProducts(),
  });
};